import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { ComingSoonModalComponent } from './components/coming-soon-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ComingSoonModalComponent],
  template: `
    <router-outlet></router-outlet>
    <app-coming-soon-modal></app-coming-soon-modal>
  `
})
export class App {
  title = 'colorfol-distrib';

  constructor(private translate: TranslateService) {
    this.translate.addLangs(['en', 'fr']);
    this.translate.setDefaultLang('en');

    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang?.match(/en|fr/) ? browserLang : 'en');
  }
}
